export default __webpack_public_path__ + "static/media/repeat.9539c5ac.jpg";